export const DEFAULT_NUMBER_OF_UNITS = 3;
